/**
 * @file
 */

import { hideFieldErrorPrompt } from "@/common/validation/utils.js";
import { customValidationInit } from "@/common/validation/init.js";

export function InitializeUploadFilePage() {
  customValidationInit(false);

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-15
  window.selectDocumentType = selectDocumentType;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-15
  window.resetDocumentType = resetDocumentType;
}

/**
 * 
 * @param {string} blankFormKey
 * @param {string} title
 * @param {string} formTypeKey
 */
function selectDocumentType(blankFormKey, title, formTypeKey) {
  // store the blankformkey, document title, and form type (IPL or ICQ) in the hidden fields
  $("[id$='hfDocumentType']").val(blankFormKey);
  $("[id$='hfDocumentName']").val(title);
  $("[id$='hfFormKeyType']").val(formTypeKey);

  // store the title in the selected document label
  $("[id$='lblDocumentTypeSelected']").text(title);

  // clear any validation bubbles on the category section
  hideFieldErrorPrompt('pnlCategories');

  // hide the select accordion
  $("[id$='divDocumentTypeSelect']").toggleClass('ui-helper-hidden', true);

  // show the selection
  $("[id$='divDocumentTypeSelected']").toggleClass('ui-helper-hidden', false);

}

function resetDocumentType() {
  $("[id$='hfDocumentType']").val("");
  $("[id$='hfDocumentName']").val("");

  // store the title in the selected document label
  $("[id$='lblDocumentTypeSelected']").text("None Selected");

  // show the select accordion
  $("[id$='divDocumentTypeSelect']").toggleClass('ui-helper-hidden', false);

  // hide the selection
  $("[id$='divDocumentTypeSelected']").toggleClass('ui-helper-hidden', true);
}
